let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5bZqt")).then(() => parcelRequire('lxB4O'));